import Axios from 'axios';

export default {
  data() {
    return {
      TOKEN: this.$store.state.token,
      me: this.$store.state.me,
      company: {
      },
      community: {
        users: [],
      },
      muralInput: '',
      muralForm: {
        users: [],
        body: '',
      },
      usersFilter: {
        name: '',
        state: '',
        specialities: [],
      },
      states: [],
      specialities: [],
      specialitiesInput: '',
      collapse: {
        mural: true,
      },
    }
  },

  mounted() {
    var _this = this;

    axios
      .get('/api/v1/companies/' + this.me.company_id, {
        headers: {
          Authorization: 'Bearer ' + this.TOKEN,
        }
      })
      .then(response => {
        if (!response.data.error) {
          _this.company = response.data.data;
          // console.log(_this.company);
          axios
            .get('/api/v1/communities/' + _this.company.community.id, {
              headers: {
                Authorization: 'Bearer ' + this.TOKEN,
              }
            })
            .then(response => {
              if (!response.data.error) {
                _this.community = response.data.data;
                // console.log(_this.community);
              } else {
                console.log(response.data.error);
              }
            });
        } else {
          console.log(response.data.error);
        }
      });

    axios
      .get('/api/v1/specialities', {
        headers: {
          Authorization: 'Bearer ' + this.TOKEN,
        }
      })
      .then(response => {
        if (!response.data.error) {
          this.specialities = response.data.data;
        }
      });

    axios
      .get('/api/v1/states', {
        headers: {
          Authorization: 'Bearer ' + this.TOKEN,
        }
      })
      .then(response => {
        if (!response.data.error) {
          this.states = response.data.data;
        }
      });
  },

  computed: {
    filteredMembers() {
      let _this = this;
      let retorno = _this.community.users;
      if (_this.usersFilter.name) retorno = retorno.filter((e) => {
        let search = _this.usersFilter.name.toLowerCase();
        let name = e.name ? e.name.toLowerCase() : '';
        let lastname = e.last_name ? e.last_name.toLowerCase() : '';
        return name.includes(search) || lastname.includes(search);
      });

      if (_this.usersFilter.specialities.length) {
        let mapped = _this.usersFilter.specialities.map((e) => e.id);
        retorno = retorno.filter(user => user.specialities.map(speciality => speciality.id).some(e => mapped.includes(e)))
      }

      if (_this.usersFilter.state) {
        retorno = retorno.filter((e) => e.profile && e.profile.state_id == _this.usersFilter.state);
      }
      return retorno;
    },
  },

  methods: {
    validateListMural(e) {
      let text = this.muralInput;
      let index = this.community.users.map(function (e) { return e.name; }).indexOf(text);
      let double = this.muralForm.users.map(function (e) { return e.name; }).indexOf(text);
      // faz parte da lista
      if (index > -1) {
        // não está ainda na lista selecionada
        if (double < 0) this.muralForm.users.push(this.community.users[index]);
        this.muralInput = '';
      }
    },

    removeMural(user) {
      // remove da lista
      let index = this.muralForm.users.map(function (e) { return e.id; }).indexOf(user.id);
      if (index > -1) {
        this.muralForm.users.splice(index, 1);
      }
    },

    sendMural() {
      let data = {};
      if (!this.muralForm.body) { return; }
      if (!this.muralForm.users.length) { return; }
      data.messageBody = this.muralForm.body;
      data.members = this.muralForm.users.map((e) => e.id);
      data.community = this.community.id;
      data.allCommunity = false; // sem front
      axios
        .post('/api/v1/community_messages', data, {
          headers: {
            Authorization: 'Bearer ' + this.TOKEN,
          }
        })
        .then(response => {
          if (response.data.error) {
            // _this.errors = response.data.error;
            console.log(response.data.error);
          } else {
            this.$router.go(); // limpar campos e avisar sucesso
          }
        });
    },

    removeMember(user) {
      axios
        .delete('/api/v1/communities/' + this.community.id + '/members/' + user.id, {
          headers: {
            Authorization: 'Bearer ' + this.TOKEN,
          }
        })
        .then(response => {
          if (response.data.error) {
            // _this.errors = response.data.error;
            console.log(response.data.error);
          } else {
            let index = this.community.users.map(e => e.id).indexOf(user.id);
            if (index > -1) this.community.users.splice(index, 1);
          }
        });
    },

    validateListComplementares(e) {
      // if (this.usersFilter.specialities.length <= 4) {
      let text = this.specialitiesInput;
      let index = this.specialities.map((e) => e.pt).indexOf(text);
      let double = this.usersFilter.specialities.map((e) => e.pt).indexOf(text);
      // faz parte da lista de habilidades
      if (index > -1) {
        // não está ainda na lista selecionada de habilidades
        if (double < 0) this.usersFilter.specialities.push(this.specialities[index]);
      }
      // }
      this.specialitiesInput = '';
    },

    removeSpeciality(s) {
      // remove habilidade do briefing
      let index = this.usersFilter.specialities.indexOf(s);
      if (index > -1) {
        this.usersFilter.specialities.splice(index, 1);
      }
    },
  },
}
